export type Scene = {
  key: string;
  date: string;
  panchromatic: File,
  multiSpectral: File
}

export enum UploadStatus {
  Uploading = 1,
  Error,
  Success
}

export type TUploadStatus = {
  sceneId: string;
  scene: Scene;
  uploadController: AbortController;
  multiSpectral: UploadStatus;
  panchromatic: UploadStatus;
  totalSize: number;
  progress: {[key: string]: number};
}

export type TSceneUploadStatus = {
  [key: string]: TUploadStatus
}
